import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { isNil } from 'lodash';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Returns September 3, 2015
 */
export const convertBirthDate = (
  birthDate: Date,
  format = 'YYYY-MM-DD',
): string => dayjs(birthDate).tz('UTC').format(format);

export const calculateAge = (birthDate: Date): string => {
  if (isNil(birthDate)) {
    return '';
  }

  const today = dayjs();
  const birthday = dayjs(birthDate);

  // return days when < 2 weeks
  if (today.diff(birthday, 'day') < 15) {
    return `${today.diff(birthday, 'day')} days`;
  }

  // return weeks when < 2 months
  if (today.diff(birthday, 'month') < 2) {
    return `${
      Math.round(today.diff(birthday, 'week', true) * 100) / 100
    } weeks`;
  }

  // return months when < 2 years
  if (today.diff(birthday, 'year') < 2) {
    return `${today.diff(birthday, 'month')} months`;
  }

  // return years by default
  return `${today.diff(birthday, 'year')} years`;
};

export const calculateAgeNumber = (birthDate: Date): number => {
  if (isNil(birthDate)) {
    return 100;
  }

  const today = dayjs();
  const birthday = dayjs(birthDate);

  return today.diff(birthday, 'year');
};

export const isUnder2Years = (birthDate: Date): boolean => {
  if (isNil(birthDate)) {
    return false;
  }

  const today = dayjs();
  const birthday = dayjs(birthDate);
  return today.diff(birthday, 'year') < 2;
};

export const calculateAgeInMonths = (birthDate: Date): number => {
  if (isNil(birthDate)) {
    throw new Error('birthDate is required');
  }

  const today = dayjs();
  const birthday = dayjs(birthDate);

  return today.diff(birthday, 'month');
};
